import { EnhancedStatisticsService } from './enhancedStatisticsService';
import { statisticsService } from './statisticsService'; // Your existing service
import { User } from './storageTypes';

export class StorageServiceFactory {
  private static instance: EnhancedStatisticsService | null = null;
  
  static getStatisticsService(user: User | null = null): EnhancedStatisticsService {
    if (!this.instance) {
      this.instance = new EnhancedStatisticsService(user);
    } else if (user) {
      this.instance.setUser(user);
    }
    
    return this.instance;
  }

  // For gradual migration - returns old service if needed
  static getLegacyService() {
    return statisticsService;
  }
} 